// extracted by mini-css-extract-plugin
export default {"label":"Shared_label__Zfjwb"};